/**
 * Un modo solo di comprare Pro, qualunque sia la piattaforma.
 *
 * L'interfaccia è questa, e non cambia da nessuna parte:
 *
 *   getProducts()              -> Promise<Prodotto[]>   lista vuota = qui non si compra
 *   purchase(productId, {uid}) -> Promise<boolean>      false = foglio chiuso dall'utente
 *   restore({uid})             -> Promise<boolean>      true = Pro attivo sull'account
 *   openManageSubscription()   -> Promise<boolean>
 *
 * Un Prodotto è `{ id, plan, price, period, hasMonthlyEquiv, perMonth, trial }`:
 * `trial` è `{ count, unit }` solo se lo store ha una prova gratuita. `price` è già
 * la stringa da mostrare, arriva dal prodotto dello store ed è localizzata per
 * paese. Mostrare un prezzo diverso da quello che l'utente paga è motivo di
 * rifiuto, quindi non si calcola qui.
 *
 * Si compra solo dentro l'app (#74): il web non vende più.
 */

import { nativeBilling } from "./nativeBilling";

export function getBilling() {
  return nativeBilling;
}
